import type * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import { Button } from '@gitbook/spine-react';

/**
 * Button to open the integrations side sheet.
 */
export function SpaceIntegrationsButton(props: { space: api.Space }) {
    const { space } = props;

    return space.permissions.admin ? (
        <Button
            kind="blank"
            label="Integrations"
            title="Install and configure integrations for this space"
            iconOnly
            leadingIcon={Icon.Integrations}
            className="max-sm:hidden"
            href={{ current: { sideSheet: { type: 'integrations' } } }}
        />
    ) : null;
}
